import { render, staticRenderFns } from "./SegurMain.vue?vue&type=template&id=6c88fdc8&scoped=true"
import script from "./SegurMain.vue?vue&type=script&lang=js"
export * from "./SegurMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c88fdc8",
  null
  
)

export default component.exports